/* MaxHealth PDP — variant pills, subscribe toggle, thumb gallery, sticky CTA.
   Vanilla web components, no framework. */

(function () {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.variantInput = this.querySelector('[data-variant-id-input]');
      this.sellingPlanInput = this.querySelector('[data-selling-plan-input]');
      this.priceEl = document.getElementById('mh-pdp-price');
      this.priceCurrent = this.priceEl?.querySelector('.mh-pdp__price-current');
      this.priceCompare = this.priceEl?.querySelector('.mh-pdp__price-compare');
      this.addBtn = this.querySelector('[data-add-button]');
      this.addLabel = this.querySelector('[data-add-label]');
      this.intervalWrap = this.querySelector('[data-interval-wrap]');
      this.intervalSelect = this.querySelector('[data-interval-select]');
      this.purchaseToggle = this.querySelector('[data-purchase-toggle]');
      this.variantPicker = this.querySelector('[data-variant-picker]');
      this.variantDataScript = this.querySelector('[data-variant-data]');
      this.priceDataScript = this.querySelector('[data-variant-prices]');

      try {
        this.variants = this.variantDataScript ? JSON.parse(this.variantDataScript.textContent) : [];
      } catch (e) { this.variants = []; }

      // Pre-formatted, money_format-respecting price strings keyed by variant id (emitted from Liquid).
      try {
        this.priceMap = this.priceDataScript ? JSON.parse(this.priceDataScript.textContent) : {};
      } catch (e) { this.priceMap = {}; }

      this.currentVariant = this.variants.find(v => String(v.id) === String(this.variantInput?.value)) || this.variants[0];

      this.bindPurchaseToggle();
      this.bindVariantPicker();
    }

    bindPurchaseToggle() {
      if (!this.purchaseToggle) return;
      this.purchaseToggle.addEventListener('change', (e) => {
        const target = e.target.closest('input[name="purchase_option"]');
        if (!target) return;
        const isSubscribe = target.value === 'subscribe';
        this.purchaseToggle.querySelectorAll('.mh-pdp__pill').forEach(p => {
          p.classList.toggle('is-active', p.dataset.option === target.value);
        });
        if (this.intervalWrap) {
          this.intervalWrap.hidden = !isSubscribe;
        }
        if (this.sellingPlanInput) {
          if (isSubscribe && this.intervalSelect?.value) {
            this.sellingPlanInput.value = this.intervalSelect.value;
            this.sellingPlanInput.disabled = false;
          } else {
            this.sellingPlanInput.value = '';
            this.sellingPlanInput.disabled = true;
          }
        }
      });

      if (this.intervalSelect) {
        this.intervalSelect.addEventListener('change', () => {
          if (this.sellingPlanInput && !this.sellingPlanInput.disabled) {
            this.sellingPlanInput.value = this.intervalSelect.value;
          }
        });
      }
    }

    bindVariantPicker() {
      if (!this.variantPicker) return;
      this.variantPicker.addEventListener('change', () => this.onOptionChange());
    }

    onOptionChange() {
      const selected = Array.from(this.variantPicker.querySelectorAll('input[type="radio"]:checked'))
        .sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex))
        .map(r => r.value);

      const match = this.variants.find(v =>
        v.options.length === selected.length &&
        v.options.every((opt, i) => opt === selected[i])
      );

      if (!match) return;
      this.currentVariant = match;
      if (this.variantInput) this.variantInput.value = match.id;

      this.variantPicker.querySelectorAll('.mh-pdp__pill--option').forEach(label => {
        const input = label.querySelector('input');
        label.classList.toggle('is-active', input?.checked);
      });

      const prices = this.priceMap[match.id];
      if (this.priceCurrent && prices) this.priceCurrent.textContent = prices.price;
      if (this.priceCompare) {
        if (prices && prices.compareAt) {
          this.priceCompare.textContent = prices.compareAt;
          this.priceCompare.hidden = false;
        } else {
          this.priceCompare.hidden = true;
        }
      }

      if (this.addBtn && this.addLabel) {
        this.addBtn.disabled = !match.available;
        this.addLabel.textContent = match.available ? 'Add to bag' : 'Sold out';
      }

      const stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyPrice && prices) stickyPrice.textContent = prices.price;

      const url = new URL(window.location);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  if (!customElements.get('product-form')) {
    customElements.define('product-form', ProductForm);
  }

  /* ---- Thumb gallery ---- */
  document.querySelectorAll('.mh-pdp__thumb-button').forEach(btn => {
    btn.addEventListener('click', () => {
      const src = btn.dataset.mediaSrc;
      const main = document.getElementById('mh-pdp-media-main');
      if (!main || !src) return;
      main.setAttribute('src', src);
      main.setAttribute('srcset', src);
      document.querySelectorAll('.mh-pdp__thumb-button').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
    });
  });

  /* ---- Sticky CTA on mobile ---- */
  const sticky = document.querySelector('[data-sticky-cta]');
  const addBtnRef = document.querySelector('[data-add-button]');
  const stickyAdd = document.querySelector('[data-sticky-add]');
  const form = document.querySelector('product-form form');

  if (sticky && addBtnRef && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          const isMobile = window.matchMedia('(max-width: 989px)').matches;
          if (!isMobile) {
            sticky.hidden = true;
            return;
          }
          sticky.hidden = entry.isIntersecting;
        });
      },
      { threshold: 0, rootMargin: '0px 0px -80px 0px' }
    );
    observer.observe(addBtnRef);
  }

  if (stickyAdd && form) {
    stickyAdd.addEventListener('click', () => {
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  }
})();
